import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e3) { throw _e3; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e4) { didErr = true; err = _e4; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var Q = Object.defineProperty,
    V = Object.defineProperties;
var W = Object.getOwnPropertyDescriptors;
var G = Object.getOwnPropertySymbols;
var J = Object.prototype.hasOwnProperty,
    X = Object.prototype.propertyIsEnumerable;

var I = function I(t, n, i) {
  return n in t ? Q(t, n, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: i
  }) : t[n] = i;
},
    o = function o(t, n) {
  for (var i in n || (n = {})) {
    J.call(n, i) && I(t, i, n[i]);
  }

  if (G) {
    var _iterator = _createForOfIteratorHelper(G(n)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var i = _step.value;
        X.call(n, i) && I(t, i, n[i]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return t;
},
    m = function m(t, n) {
  return V(t, W(n));
};

import { id as M, makeEvent as K } from "@stackflow/core";
import j from "react";

function H(t) {
  return t.length === 0 ? void 0 : t[t.length - 1];
}

import Y from "url-pattern";

function Z(t) {
  return new URL(t, "file://");
}

function tt(t) {
  var n = {};
  return t.forEach(function (i, e) {
    n[e] = i;
  }), n;
}

function et(t) {
  return t.endsWith("/") ? t : "".concat(t, "/");
}

function nt(t) {
  return t.toString().length > 0 ? "?".concat(t) : t;
}

function l(t) {
  var n = new Y("".concat(t, "(/)"));
  return {
    fill: function fill(i) {
      var u;
      var e = n.stringify(i),
          s = (u = n.match(e)) != null ? u : {},
          a = o({}, i);
      Object.keys(s).forEach(function (p) {
        delete a[p];
      });
      var c = new URLSearchParams(a);
      return et(e) + nt(c);
    },
    parse: function parse(i) {
      var e = Z(i),
          s = n.match(e.pathname),
          a = tt(e.searchParams);
      return s ? o(o({}, a), s) : null;
    }
  };
}

function f(t) {
  return typeof t == "string" ? [t] : t;
}

import rt, { createContext as st, useContext as it } from "react";

var U = st({}),
    $ = function $(t) {
  return rt.createElement(U.Provider, {
    value: t.routes
  }, t.children);
};

function at() {
  return it(U);
}

var g = "@stackflow/plugin-history-sync@0.16.0",
    ot = 1e3,
    O = 60 * ot,
    R = typeof window == "undefined";

function F() {
  return R ? null : window.history.state;
}

function b(t) {
  var n = t;
  return typeof n == "object" && n !== null && "_TAG" in n && typeof n._TAG == "string" && n._TAG === g ? t : null;
}

function D(_ref) {
  var t = _ref.state,
      n = _ref.url,
      i = _ref.useHash;
  if (R) return;
  var e = i ? "".concat(window.location.pathname, "#").concat(n) : n;
  window.history.pushState(t, "", e);
}

function E(_ref2) {
  var t = _ref2.url,
      n = _ref2.state,
      i = _ref2.useHash;
  if (R) return;
  var e = i ? "".concat(window.location.pathname, "#").concat(t) : t;
  window.history.replaceState(n, "", e);
}

function A(t) {
  return m(o({}, t), {
    context: void 0,
    pushedBy: m(o({}, t.pushedBy), {
      activityContext: void 0
    })
  });
}

var L,
    St = (L = j.startTransition) != null ? L : function (t) {
  return t();
};

function At(t) {
  return function () {
    var n = 0,
        i = 0;
    return {
      key: "plugin-history-sync",
      wrapStack: function wrapStack(_ref3) {
        var e = _ref3.stack;
        return j.createElement($, {
          routes: t.routes
        }, e.render());
      },
      overrideInitialEvents: function overrideInitialEvents(_ref4) {
        var e = _ref4.initialContext;
        var v, P;
        var s = b(F());
        if (s) return [m(o({}, s.activity.pushedBy), {
          name: "Pushed"
        })].concat(_toConsumableArray(((v = s.step) == null ? void 0 : v.pushedBy.name) === "StepPushed" || ((P = s.step) == null ? void 0 : P.pushedBy.name) === "StepReplaced" ? [m(o({}, s.step.pushedBy), {
          name: "StepPushed"
        })] : []));

        function a() {
          var r, y;
          return ((r = e == null ? void 0 : e.req) == null ? void 0 : r.path) && typeof e.req.path == "string" ? e.req.path : R ? null : t.useHash ? (y = window.location.hash.split("#")[1]) != null ? y : "/" : window.location.pathname + window.location.search;
        }

        var c = a(),
            u = Object.keys(t.routes);
        if (c) for (var r = 0; r < u.length; r += 1) {
          var y = u[r],
              d = f(t.routes[y]);

          for (var h = 0; h < d.length; h += 1) {
            var B = d[h],
                k = l(B).parse(c);

            if (!!k) {
              var x = M();
              return [K("Pushed", {
                activityId: x,
                activityName: y,
                activityParams: o({}, k),
                eventDate: new Date().getTime() - O,
                activityContext: {
                  path: c
                }
              })];
            }
          }
        }
        var p = M(),
            T = t.fallbackActivity({
          initialContext: e
        }),
            w = f(t.routes[T])[0];
        return [K("Pushed", {
          activityId: p,
          activityName: T,
          activityParams: {},
          eventDate: new Date().getTime() - O,
          activityContext: {
            path: w
          }
        })];
      },
      onInit: function onInit(_ref5) {
        var _ref5$actions = _ref5.actions,
            e = _ref5$actions.getStack,
            s = _ref5$actions.dispatchEvent,
            a = _ref5$actions.push,
            c = _ref5$actions.stepPush;
        var u = e().activities[0],
            p = l(f(t.routes[u.name])[0]);
        window.getStack = e, E({
          url: p.fill(u.params),
          state: {
            _TAG: g,
            activity: A(u),
            step: H(u.steps)
          },
          useHash: t.useHash
        });

        var T = function T(N) {
          if (i) {
            i -= 1;
            return;
          }

          var w = b(N.state);
          if (!w) return;

          var v = w.activity,
              P = w.activity.id,
              r = w.step,
              _e = e(),
              y = _e.activities,
              d = y.find(function (S) {
            return S.isActive;
          });

          if (!d) return;

          var h = H(d.steps),
              B = y.find(function (S) {
            return S.id === P;
          }),
              _ = d.steps.find(function (S) {
            return S.id === (r == null ? void 0 : r.id);
          }),
              k = function k() {
            return d.id > P;
          },
              C = function C() {
            return d.id < P;
          },
              x = function x() {
            return d.id === P;
          },
              q = function q() {
            return x() ? !!(!r || h && h.id > r.id) : !1;
          },
              z = function z() {
            return x() ? !!(!h || r && h.id < r.id) : !1;
          };

          if (k() && (s("Popped", {}), B || (n += 1, a(o({}, v.pushedBy)), ((r == null ? void 0 : r.pushedBy.name) === "StepPushed" || (r == null ? void 0 : r.pushedBy.name) === "StepReplaced") && (n += 1, c(o({}, r.pushedBy))))), q() && (!_ && r && ((r == null ? void 0 : r.pushedBy.name) === "StepPushed" || (r == null ? void 0 : r.pushedBy.name) === "StepReplaced") && (n += 1, c(o({}, r.pushedBy))), s("StepPopped", {})), C() && (n += 1, a({
            activityId: v.id,
            activityName: v.name,
            activityParams: v.params
          })), z()) {
            if (!r) return;
            n += 1, c({
              stepId: r.id,
              stepParams: r.params
            });
          }
        };

        R || window.addEventListener("popstate", T);
      },
      onPushed: function onPushed(_ref6) {
        var e = _ref6.effect.activity;

        if (n) {
          n -= 1;
          return;
        }

        var s = l(f(t.routes[e.name])[0]);
        D({
          url: s.fill(e.params),
          state: {
            _TAG: g,
            activity: A(e)
          },
          useHash: t.useHash
        });
      },
      onStepPushed: function onStepPushed(_ref7) {
        var _ref7$effect = _ref7.effect,
            e = _ref7$effect.activity,
            s = _ref7$effect.step;

        if (n) {
          n -= 1;
          return;
        }

        var a = l(f(t.routes[e.name])[0]);
        D({
          url: a.fill(e.params),
          state: {
            _TAG: g,
            activity: A(e),
            step: s
          },
          useHash: t.useHash
        });
      },
      onReplaced: function onReplaced(_ref8) {
        var e = _ref8.effect.activity;
        if (!e.isActive) return;
        var s = l(f(t.routes[e.name])[0]);
        E({
          url: s.fill(e.params),
          state: {
            _TAG: g,
            activity: A(e)
          },
          useHash: t.useHash
        });
      },
      onStepReplaced: function onStepReplaced(_ref9) {
        var _ref9$effect = _ref9.effect,
            e = _ref9$effect.activity,
            s = _ref9$effect.step;
        if (!e.isActive) return;
        var a = l(f(t.routes[e.name])[0]);
        E({
          url: a.fill(e.params),
          state: {
            _TAG: g,
            activity: A(e),
            step: s
          },
          useHash: t.useHash
        });
      },
      onBeforePush: function onBeforePush(_ref10) {
        var e = _ref10.actionParams,
            s = _ref10.actions.overrideActionParams;
        var c = l(f(t.routes[e.activityName])[0]).fill(e.activityParams);
        s(m(o({}, e), {
          activityContext: m(o({}, e.activityContext), {
            path: c
          })
        }));
      },
      onBeforeReplace: function onBeforeReplace(_ref11) {
        var e = _ref11.actionParams,
            s = _ref11.actions.overrideActionParams;
        var c = l(f(t.routes[e.activityName])[0]).fill(e.activityParams);
        s(m(o({}, e), {
          activityContext: m(o({}, e.activityContext), {
            path: c
          })
        }));
      },
      onBeforePop: function onBeforePop(_ref12) {
        var e = _ref12.actions.getStack;
        var u;
        if (typeof window == "undefined") return;

        var _e2 = e(),
            s = _e2.activities,
            a = s.find(function (p) {
          return p.isActive;
        }),
            c = (u = a == null ? void 0 : a.steps.length) != null ? u : 0;

        i += c;

        do {
          for (var p = 0; p < c; p += 1) {
            window.history.back();
          }
        } while (!b(F()));
      }
    };
  };
}

export { At as historySyncPlugin, l as makeTemplate, f as normalizeRoute, at as useRoutes };